import { cloneElement, MouseEvent, useEffect, useRef } from 'react';
import { _UITooltipController } from './TooltipController';

interface TooltipProps {
    children: any;
    /** Text to show inside tooltip */
    title?: string;
    /** Custom content to show inside tooltip */
    content?: any;
    /** Origin position of Tooltip */
    originPosition?: { x: 'right' | 'left' | 'center', y: 'top' | 'bottom' | 'center' };
    /** Mount position on target to which Tooltip will mount  */
    anchorPosition?: { x: 'right' | 'left' | 'center', y: 'top' | 'bottom' | 'center' };
    offset?: { x: number, y: number };
    naked?: boolean;
}


export default function Tooltip(props: TooltipProps) {
    const id = useRef<number>();

    function onMouseEnter(e: MouseEvent) {
        e.stopPropagation();
        const target = e.currentTarget as HTMLElement;
        const timeout = setTimeout(() => {
            const tooltipID = _UITooltipController.add({ children: props.title || props.content, event: e, target: target, originPosition: props.originPosition, anchorPosition: props.anchorPosition, offset: props.offset, naked: props.naked });
            if (tooltipID) id.current = tooltipID;
        }, 100);
        const originalLeave = target.onmouseleave
        target.onmouseleave = (e, ...rest) => { clearTimeout(timeout); if (originalLeave) (originalLeave as any)(e, ...rest) };
    }
    //TODO: REDO TO PORTAL
    useEffect(() => {
        if (!id.current) return;
        _UITooltipController.update(id.current, { children: props.content })
        if (_UITooltipController.controllerRender) _UITooltipController.controllerRender();
    }, [props.content]);

    return (
        <>
            {cloneElement(props.children, { onMouseEnter })}
        </>
    )
}